"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withRenderProps;
function withRenderProps(hoc) {
  var RenderPropsComponent = function RenderPropsComponent(props) {
    return props.children(props);
  };
  return hoc(RenderPropsComponent);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/recompose/withRenderProps.js
// module id = 1350
// module chunks = 0